import classNames from "classnames";
import React, { FC, useEffect, useState } from "react";
import { MdCopyAll } from "react-icons/md";
import { useCopyToClipboard } from "react-use";

type CopyToClipboardProps = {
  style?: React.CSSProperties;
  onCopy: () => string;
};

const CopyToClipboard: FC<CopyToClipboardProps> = ({ style, onCopy }) => {
  const [_clipboardText, setClipboardText] = useCopyToClipboard();
  const [showAnimation, setShowAnimation] = useState(false);

  const onClickHandler = () => {
    setClipboardText(onCopy());
    setShowAnimation(!showAnimation);
  };

  useEffect(() => {
    showAnimation && setTimeout(() => setShowAnimation(false), 900);
  }, [showAnimation]);

  return (
    <div
      onClick={onClickHandler}
      className={classNames("relative", {
        "animate-ping": showAnimation,
      })}
    >
      <MdCopyAll style={style} />
    </div>
  );
};

export default CopyToClipboard;
